<template>
    <v-container fluid>
        <div class="modal-padding">
            <v-row>
                <v-col cols="12" sm="12">
                    <div class="center-name">{{ getDialogTitle() }}</div>
                </v-col>
                <v-col cols="12" sm="12" class="zero-top">
                    <v-text-field
                        v-model="batchName"
                        label="Batch Name"
                        class="required"
                        dense
                        outlined
                        hide-details
                    ></v-text-field>
                    <InputError :data="error.batch" />
                </v-col>
                <v-col
                    v-if="data.isDupicate"
                    cols="12"
                    sm="12"
                    class="zero-top"
                >
                    <v-select
                        ref="center"
                        @change="changeCenter"
                        @focus="focused"
                        @blur="blurred"
                        v-model="selectedCenter"
                        :items="centers"
                        label="Centers"
                        dense
                        hide-details
                        outlined
                        class="required"
                    ></v-select>
                    <InputError :data="error.dataType" />
                </v-col>
                <v-col cols="12" sm="12" class="zero-top">
                    <v-select
                        ref="category"
                        v-model="selectedDataType"
                        :items="dataTypes"
                        label="Category"
                        @focus="focused"
                        @blur="blurred"
                        dense
                        hide-details
                        outlined
                        class="required"
                    ></v-select>
                    <InputError :data="error.dataType" />
                </v-col>
                <v-col cols="12" sm="12" class="zero-top multi-selectcust">
                    <multi-select-input
                        allText="All Subjects"
                        :items="subjects"
                        label="Select Subjects"
                        :onChange="onSubjectChanged"
                        :selectedItemsList="selectedSubjects"
                        :persistentStatus="persistentStatus"
                        content-class="selectcust-multi"
                    ></multi-select-input>
                    <InputError :data="error.subjects" />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12">
                    <div class="right-align">
                        <v-btn
                            @click="onDone"
                            :loading="loading"
                            class="right-btn cust-btn"
                            color="primary"
                            >Done</v-btn
                        >
                    </div>
                </v-col>
            </v-row>
        </div>
    </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
    name: "AddBatch",
    props: ["onClose", "status", "data"],
    mounted() {
        this.requestGetDataTypes();
        this.preSelectedData();
        this.selectedCenter = this.data.selectedCenter.id;

        if (this.data.isDupicate) {
            this.centers = this.data.centersForDuplicate;
        }
    },
    data() {
        return {
            centers: [],
            selectedCenter: null,
            menuValue: { value: false },
            batchName: null,
            dataTypes: [],
            selectedDataType: null,
            subjects: [],
            loading: false,
            selectedSubjects: [],
            addPreloadSubjects: false,
            error: {
                batch: {
                    type: null,
                    message: "Please enter batch name",
                },
                dataType: {
                    type: null,
                    message: "Please select data type",
                },
                subjects: {
                    type: null,
                    message: "Please select subjects",
                },
            },
            selectedCenter: null,
        };
    },
    methods: {
        ...mapActions({
            getInstituteDataTypes: "utilStore/getInstituteDataTypes",
            getDataTreeWithLevel: "utilStore/getDataTreeWithLevel",
            upsertBatch: "centerAndBatchStore/upsertBatch",
        }),
        changeCenter() {
            this.$refs.center.blur();
        },
        focused() {
            this.persistentStatus(true);
        },
        blurred(e) {
            _.debounce(this.persistentStatus, 200)(false, this);
        },
        persistentStatus(val) {
            this.$nextTick(() => {
                this.$emit("persistentStatus", val);
            });
        },
        preSelectedData() {
            if (this.data && this.data.batch) {
                this.batchName = this.data.isDupicate
                    ? ""
                    : this.data.batch.name;

                if (this.data.batch.subject_ids) {
                    let tmpSubject = this.data.batch.subject_ids.split(",");
                    let subjectIds = this.subjects.map(
                        (s) => s.value.subject_id + ""
                    );
                    if (tmpSubject && tmpSubject.length) {
                        this.selectedSubjects = [];
                        tmpSubject.map((x) => {
                            if (subjectIds.includes(x)) {
                                this.selectedSubjects.push({
                                    subject_id: parseInt(x),
                                });
                            }
                        });
                    }
                }
                this.addPreloadSubjects = true;
                this.selectedDataType = this.data.batch.datatype_id;
            }
        },
        onSubjectChanged(selectedSubjects) {
            this.selectedSubjects = selectedSubjects;
        },
        requestGetDataTypes() {
            this.$root.showLoader = true;
            this.getInstituteDataTypes()
                .then((response) => {
                    this.$root.showLoader = false;
                    this.dataTypes = response.map((x) => {
                        let c = {};
                        c.text = x.title;
                        c.value = x.id;
                        return c;
                    });
                })
                .catch((err) => {
                    this.$root.showLoader = false;
                });
        },
        onDone() {
            if (this.validate()) {
                let reqData = {
                    id:
                        this.data && !this.data.isDupicate && this.data.batch
                            ? this.data.batch.id
                            : null,
                    center_id: this.selectedCenter,
                    name: this.batchName,
                    subjects: this.selectedSubjects,
                };
                this.loading = true;
                this.upsertBatch(reqData)
                    .then((response) => {
                        this.loading = false;
                        if (
                            this.data.type == "Add Batch" ||
                            this.selectedCenter != this.data.selectedCenter.id
                        ) {
                            this.onClose({
                                status: false,
                                reloadBatches: true,
                            });
                        } else {
                            reqData.id = response.batch_id;
                            let selectedDataTypeObj = this.dataTypes.find(
                                (dt) => dt.value == this.selectedDataType
                            );

                            let data = this.data;
                            let batch = data.batch;
                            batch.id = response.batch_id;
                            batch.datatype_name = selectedDataTypeObj.text;
                            batch.datatype_id = selectedDataTypeObj.value;
                            batch.name = this.batchName;
                            data.batch = batch;
                            let subjectIds = this.selectedSubjects.map(
                                (ss) => ss.subject_id
                            );

                            this.onClose({
                                status: false,
                                reloadBatches: true,
                                reqData,
                                subjects: this.subjects,
                                data,
                                subjectIds,
                            });
                        }
                        this.$toasted.success(`${response.msg}`, {
                            icon: "check_circle",
                        });
                    })
                    .catch((err) => {
                        this.loading = false;
                    });
            }
        },
        validate() {
            let isValid = true;
            this.error.subjects.type = null;
            this.error.batch.type = null;

            if (!this.batchName || this.batchName.trim().length < 1) {
                this.error.batch.type = "error";
                isValid = false;
            }

            if (!this.selectedDataType) {
                this.error.dataType.type = "error";
                isValid = false;
            }

            if (!this.selectedSubjects || this.selectedSubjects.length < 1) {
                this.error.subjects.type = "error";
                isValid = false;
            }

            return isValid;
        },
        getDialogTitle() {
            if (this.data.isDupicate) {
                return "Add new batch";
            } else if (this.data.batch) {
                return "Edit batch";
            } else {
                return "Add new batch";
            }
        },
        checkSelectedSubject() {
            let tmpSubject = this.data.batch.subject_ids.split(",");
            let subjectIds = this.subjects.map((s) => s.value.subject_id + "");
            if (tmpSubject && tmpSubject.length) {
                this.selectedSubjects = [];
                tmpSubject.map((x) => {
                    if (subjectIds.includes(x)) {
                        this.selectedSubjects.push({
                            subject_id: parseInt(x),
                        });
                    }
                });
            }
        },
    },
    watch: {
        status(val) {
            this.selectedCenter = this.data.selectedCenter.id;

            if (this.data.isDupicate) {
                this.centers = this.data.centersForDuplicate;
            }

            this.error.batch.type = null;
            this.error.dataType.type = null;
            this.error.subjects.type = null;
            if (val) {
                this.preSelectedData();
            } else {
                this.selectedDataType = null;
                this.subjects = [];
                this.batchName = null;
                this.selectedSubjects = [];
            }
        },
        selectedSubjects(val) {
            if (val && val.length) {
                this.error.subjects.type = null;
            }
        },
        batchName(val) {
            if (val && val.trim().length) {
                this.error.batch.type = null;
            }
        },

        selectedDataType(val) {
            this.selectedSubjects = [];
            this.$refs.category.blur();

            if (val) {
                this.error.dataType.type = null;
                let reqData = {
                    level: 2,
                    parent: val,
                };
                this.$root.showLoader = true;

                this.getDataTreeWithLevel(reqData)
                    .then((response) => {
                        this.$root.showLoader = false;
                        this.subjects = response.map((x) => {
                            let c = {};
                            c.text = x.title;
                            c.value = { subject_id: x.id };

                            return c;
                        });
                        this.checkSelectedSubject();
                        this.addPreloadSubjects = false;
                    })
                    .catch((err) => {
                        this.$root.showLoader = false;
                    });
            }
        },
    },
};
</script>
